import { Navigate, Outlet } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { LOGIN_ROUTE } from "../routes";

const PrivateRoutes: React.FC = () => {
  const { isLoggedIn } = useAuth();
  return isLoggedIn ? <Outlet /> : <Navigate to={LOGIN_ROUTE} />;
};

export default PrivateRoutes;
